<template>
  <v-container>
    <v-tab-item class="pb-12">
      <validation-observer v-slot="{ valid }">
        <validation-helper :interceptor="valid" @isValid="$emit('secondStepAvailable', $event)" />

        <div class="display-1 font-weight-normal mb-6 text-center">Vamos começar preenchendo as informações básicas</div>
        <v-row class="mx-auto">
          <v-col cols="12">
            <v-alert dense outlined type="info" color="blue" class="mb-4 px-1 py-0">
              NÃO são utilizadas as TIs: 10 a 29, 70 a 92, 94, 95, 97 a 99.
            </v-alert>
            <validation-provider v-slot="{ errors }" rules="required">
              <v-text-field id="titulo-comparativo" v-model="campos.titulo" label="Título" outlined :error-messages="errors" />
            </validation-provider>
          </v-col>
        </v-row>
        <v-row id="data-imobilizacao-comparativo" class="mx-auto">
          <v-col cols="5">
            <v-menu
              v-model="menuPickerImobInicio"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <validation-provider
                  v-slot="{ errors }"
                  :rules="{ required_if: campos.dataFormattedImobFim != null && campos.dataFormattedImobFim.length > 0, min: 10 }"
                >
                  <v-text-field
                    v-model="campos.dataFormattedImobInicio"
                    v-mask="'##/##/####'"
                    :error-messages="errors"
                    class="pt-0"
                    label="Data Imobilização"
                    prepend-icon="mdi-calendar"
                    clearable
                    v-bind="attrs"
                    v-on="on"
                    @blur="campos.dataImobInicio = parseDate(campos.dataFormattedImobInicio)"
                  />
                </validation-provider>
              </template>
              <v-date-picker
                v-model="campos.dataImobInicio"
                locale="pt-br"
                @input="
                  menuPickerImobInicio = false;
                  campos.dataFormattedImobInicio = formatDate(campos.dataImobInicio);
                "
              />
            </v-menu>
          </v-col>
          <v-col class="pt-6 text-center" style="min-width: 60px !important" cols="1">
            <span style="color: rgba(0, 0, 0, 0.54); font-size: 15px">até</span>
          </v-col>
          <v-col cols="5">
            <v-menu
              v-model="menuPickerImobFim"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <validation-provider
                  v-slot="{ errors }"
                  :rules="{
                    required_if: campos.dataFormattedImobInicio != null && campos.dataFormattedImobInicio.length > 0,
                    min: 10
                  }"
                >
                  <v-text-field
                    v-model="campos.dataFormattedImobFim"
                    v-mask="'##/##/####'"
                    :error-messages="errors"
                    class="pt-0"
                    label="Data Imobilização"
                    prepend-icon="mdi-calendar"
                    clearable
                    v-bind="attrs"
                    v-on="on"
                    @blur="campos.dataImobFim = parseDate(campos.dataFormattedImobFim)"
                  />
                </validation-provider>
              </template>
              <v-date-picker
                v-model="campos.dataImobFim"
                locale="pt-br"
                @input="
                  menuPickerImobFim = false;
                  campos.dataFormattedImobFim = formatDate(campos.dataImobFim);
                "
              />
            </v-menu>
          </v-col>
        </v-row>
        <div id="group-check-comparativo">
          <v-row class="mx-auto spacing-checkbox-sig-r">
            <v-col class="pb-0" cols="12">
              <v-checkbox v-model="campos.anual" class="mt-0" label="Comparar por ano" checked />
            </v-col>
          </v-row>
          <v-row class="mx-auto spacing-checkbox-sig-r">
            <v-col class="pb-0" cols="12">
              <v-checkbox v-model="campos.comparaTi" class="mt-0 pt-0" label="Comparar por TI" />
            </v-col>
          </v-row>
          <v-row class="mx-auto spacing-checkbox-sig-r">
            <v-col class="pb-0" cols="12">
              <v-checkbox v-model="campos.considerarTiVazia" class="mt-0 pt-0" label="Considerar TI Vazia" />
            </v-col>
          </v-row>
          <v-row class="mx-auto spacing-checkbox-sig-r">
            <v-col class="pb-0" cols="12">
              <v-checkbox v-model="campos.dataCompleta" class="mt-0 pt-0" label="Comparar por data de imobilização completa" />
            </v-col>
          </v-row>
          <v-row class="mx-auto spacing-checkbox-sig-r">
            <v-col class="pb-0" cols="12">
              <v-checkbox v-model="campos.considerarMargem" class="mt-0 pt-0" label="Considerar margem de 15% para conciliados" />
            </v-col>
          </v-row>

          <v-row class="mx-auto spacing-checkbox-sig-r mt-4">
            <v-col class="pb-0" cols="12">
              <v-checkbox
                v-model="campos.sobraFisica"
                @change="handleCheckbox"
                class="mt-0 pt-0"
                label="Incluir Todas as Situações Contábeis (SITCONT)"
              />
            </v-col>
          </v-row>
          <v-row id="situacoes-contabeis" align="center" class="mx-auto">
            <v-col cols="12">
              <validation-provider v-slot="{ errors }">
                <v-select
                  v-model="campos.situacoesContabeisSelected"
                  :error-messages="errors"
                  :items="campos.situacoesContabeis"
                  label="Situações Contábeis"
                  multiple
                  outlined
                  chips
                />
              </validation-provider>
            </v-col>
          </v-row>
        </div>
      </validation-observer>
    </v-tab-item>

    <v-tab-item class="pb-0">
      <validation-observer v-slot="{ valid }">
        <validation-helper :interceptor="valid" @isValid="$emit('thirdStepAvailable', $event)" />

        <div class="display-1 font-weight-normal mb-6 text-center">Qual a origem do AIS e tipo do SIG-R?</div>
        <v-row id="group-tipo-comparativo" align="center" class="mx-auto">
          <v-col cols="12">
            <validation-provider v-slot="{ errors }" rules="required">
              <v-radio-group
                v-model="campos.bdgd"
                :error-messages="errors"
                row
                class="mt-0 pt-0"
                @change="campos.bdgd == true ? (campos.origemAis = 'BANCO DE DADOS') : (campos.origemAis = campos.origemAis)"
              >
                <v-radio label="SIG-R Completa" :value="false" />
                <v-radio label="Apenas BDGD" :value="true" />
              </v-radio-group>
            </validation-provider>
          </v-col>
        </v-row>
        <v-row v-if="!campos.bdgd" id="origem-ais-comparativo" align="center" class="mx-auto">
          <v-col class="pb-0" cols="12">
            <validation-provider v-slot="{ errors }" rules="required">
              <v-select
                v-model="campos.origemAis"
                no-gutters
                outlined
                :items="['BANCO DE DADOS', 'ARQUIVO']"
                label="Origem AIS"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
        </v-row>
        <div id="csv-ais-comparativo">
          <v-row v-if="campos.origemAis === 'ARQUIVO'" align="center" class="mx-auto">
            <v-col class="pb-0" cols="12">
              <v-alert dense outlined type="info" color="blue" class="mb-4 px-1 py-0">
                <div v-if="campos.anual && campos.comparaTi">
                  O arquivo selecionado deve conter os campos:
                  <b>ODI, TI, TUC, A1, A2, A3, A4, A5, A6, QTD, DATA_BASE, DATA_IMOBILIZACAO, UAR_PRINCIPAL.</b>
                </div>
                <div v-else-if="campos.anual && !campos.comparaTi">
                  O arquivo selecionado deve conter os campos:
                  <b>ODI, TUC, A1, A2, A3, A4, A5, A6, QTD, DATA_BASE, DATA_IMOBILIZACAO, UAR_PRINCIPAL.</b>
                </div>
                <div v-else-if="!campos.anual && campos.comparaTi">
                  O arquivo selecionado deve conter os campos:
                  <b>ODI, TI, TUC, A1, A2, A3, A4, A5, A6, QTD, DATA_BASE, UAR_PRINCIPAL.</b>
                </div>
                <div v-else>
                  O arquivo selecionado deve conter os campos:
                  <b>ODI, TUC, A1, A2, A3, A4, A5, A6, QTD, DATA_BASE, UAR_PRINCIPAL.</b>
                </div>
                <div class="pt-1">Obs¹: Os campos do tipo data precisão estar no formato brasileiro: xx/xx/xxxx.</div>
                <div class="pt-1">Obs²: O campo QTD pode conter o nome de QTD Somatório ou QTD para ser validado.</div>
              </v-alert>
              <validation-provider v-slot="{ errors }" rules="required">
                <v-file-input
                  v-model="arquivo"
                  class="input-upload-csv"
                  label="Base AIS CSV"
                  placeholder="Selecione um arquivo CSV"
                  outlined
                  accept=".csv, .zip"
                  :show-size="!fakeFileFound"
                  truncate-length="30"
                  :loading="uploadInProgress"
                  loader-height="4"
                  :success="arquivoId && arquivo ? true : false"
                  :error-messages="errors"
                  @change="uploadNewFile()"
                />
              </validation-provider>
              <!-- Validar se o upload do arquivo foi concluido -->
              <validation-provider rules="required">
                <input type="hidden" name="validateUpload" :value="arquivoId" />
              </validation-provider>
            </v-col>
          </v-row>
          <v-row v-if="campos.origemAis === 'ARQUIVO'" align="center" class="mx-auto">
            <v-col class="pl-0" cols="12" sm="4">
              <validation-provider v-slot="{ errors }" rules="required">
                <v-text-field v-model="campos.arquivoDelimitador" label="Delimitador" outlined :error-messages="errors" />
              </validation-provider>
            </v-col>
            <v-col cols="12" sm="4">
              <validation-provider v-slot="{ errors }" rules="required">
                <v-text-field v-model="campos.arquivoInvolucro" label="Invólucro" outlined :error-messages="errors" />
              </validation-provider>
            </v-col>
            <v-col class="pr-0" cols="12" sm="4">
              <validation-provider v-slot="{ errors }" rules="required">
                <v-text-field v-model="campos.arquivoEscape" label="Escape" outlined :error-messages="errors" />
              </validation-provider>
            </v-col>
          </v-row>
        </div>
        <v-row id="data-base-bdgd-ais-comparativo" align="center" class="mx-auto">
          <v-col cols="5">
            <v-menu
              v-model="menuPickerBdgd"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <validation-provider v-slot="{ errors }" rules="required|min:7">
                  <v-text-field
                    v-model="campos.monthFormattedBdgd"
                    v-mask="'##/####'"
                    :error-messages="errors"
                    class="pt-0"
                    type="tel"
                    label="Data Base BDGD"
                    prepend-icon="mdi-calendar"
                    clearable
                    v-bind="attrs"
                    v-on="on"
                    @blur="campos.monthBdgd = parseMonth(campos.monthFormattedBdgd)"
                  />
                </validation-provider>
              </template>
              <v-date-picker
                v-model="campos.monthBdgd"
                type="month"
                locale="pt-br"
                @input="
                  menuPickerBdgd = false;
                  campos.monthFormattedBdgd = formatMonth(campos.monthBdgd);
                "
              />
            </v-menu>
          </v-col>
          <v-col cols="1" />
          <v-col v-if="!campos.bdgd" cols="5">
            <v-menu
              v-if="campos.origemAis == 'BANCO DE DADOS'"
              v-model="menuPickerAis"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <validation-provider v-slot="{ errors }" rules="required|min:7">
                  <v-text-field
                    v-model="campos.monthFormattedAis"
                    v-mask="'##/####'"
                    :error-messages="errors"
                    class="pt-0"
                    type="tel"
                    label="Data Base AIS"
                    prepend-icon="mdi-calendar"
                    clearable
                    v-bind="attrs"
                    v-on="on"
                    @blur="campos.monthAis = parseMonth(campos.monthFormattedAis)"
                  />
                </validation-provider>
              </template>
              <v-date-picker
                v-model="campos.monthAis"
                type="month"
                locale="pt-br"
                @input="
                  menuPickerAis = false;
                  campos.monthFormattedAis = formatMonth(campos.monthAis);
                "
              />
            </v-menu>
          </v-col>
        </v-row>
      </validation-observer>
    </v-tab-item>

    <v-tab-item class="pb-12">
      <validation-observer v-slot="{ valid }">
        <validation-helper :interceptor="valid" @isValid="$emit('btnFinishAvailable', $event)" />

        <div class="display-1 font-weight-normal mb-6 text-center">Para finalizar, preencha as TUCs e ODIs para comparação</div>
        <v-row id="tucs-comparativo" align="center" class="mx-auto">
          <v-col cols="12">
            <validation-provider v-slot="{ errors }" rules="required">
              <v-select
                v-model="campos.tucsSelected"
                :error-messages="errors"
                :items="campos.tucs"
                item-value="id"
                item-text="nome"
                label="TUCs"
                multiple
                outlined
                chips
              />
            </validation-provider>
          </v-col>
        </v-row>
        <v-row id="odis-comparativo" align="center" class="mx-auto">
          <v-col cols="12">
            <v-textarea
              v-model="campos.odis"
              label="ODis"
              placeholder="Insira os códigos das ODis, um código por linha"
              rows="5"
              no-resize
              clearable
              clear-icon="mdi-close-circle"
            />
          </v-col>
        </v-row>
      </validation-observer>
    </v-tab-item>
  </v-container>
</template>

<script>
  import ArquivosService from '@/services/ArquivosService.js';
  import ConfiguracoesService from '@/services/ConfiguracoesService.js';
  import TabelasService from '@/services/TabelasService';
  import dateFormatterMixins from '@/mixins/dateFormatterMixins';

  export default {
    components: {
      ValidationHelper: () => import('@/components/general/ValidationHelper.vue')
    },

    mixins: [dateFormatterMixins],

    props: {
      items: {
        type: Object,
        default: () => {}
      },
      tucs: {
        type: Array,
        default: () => []
      },
      situacoesContabeis: {
        type: Array,
        default: () => []
      }
    },

    emits: ['secondStepAvailable', 'thirdStepAvailable', 'btnFinishAvailable'],

    data() {
      return {
        menuPickerAis: false,
        menuPickerBdgd: false,
        menuPickerImobInicio: false,
        menuPickerImobFim: false,
        campos: {
          titulo: '',
          origemAis: 'BANCO DE DADOS',
          monthFormattedAis: '',
          monthAis: '',
          monthFormattedBdgd: '',
          monthBdgd: '',
          dataFormattedImobInicio: '',
          dataImobInicio: '',
          dataFormattedImobFim: '',
          dataImobFim: '',
          sobraFisica: false /* True = SITCONT (checked) */,
          bdgd: false /* False = SIG-R Completa, True = Apenas BDGD */,
          comparaTi: false /* True = Comparar por TI */,
          considerarTiVazia: false /* True = Considera TI NULL no where do arquivo resultado */,
          anual: true /* True = Comparar por ano (checked) */,
          dataCompleta: false /* True = Comparar por data de imobilização completa */,
          considerarMargem: false /* True = Considerar margem de 15% para conciliados */,
          tucs: ['125', '160', '190', '210', '255', '295', '340', '345', '565', '570', '575', '580'],
          tucsSelected: ['125', '160', '210', '295', '340', '345', '565', '570', '575'],
          situacoesContabeis: ['0', 'AT1', 'AT2', 'BOP', 'SF', 'NIM', 'NOP', 'COM', 'RT'],
          situacoesContabeisSelected: ['AT1'],
          odis: '',
          arquivoDelimitador: ';',
          arquivoInvolucro: '"',
          arquivoEscape: '"'
        },
        uploadInProgress: false,
        arquivo: undefined,
        arquivoId: '',
        fakeFileFound: false,
        syncingSituacoesContabeis: false
      };
    },

    mounted() {
      if (this.$route.params.id) {
        this.fillFields();
      } else {
        this.getParamsArquivoCsv();
        this.getUltimaDataBase();
      }
    },

    methods: {
      fillFields() {
        let comparativo = this.items;
        const todasSituacoesContabeis = Array.isArray(this.campos.situacoesContabeis) ? this.campos.situacoesContabeis : [];
        const selectedSituacoesContabeisRaw = comparativo.sobra_fisica
          ? [...todasSituacoesContabeis]
          : this.normalizeSituacoesContabeisSelected(comparativo.situacoes_contabeis);
        const selectedSituacoesContabeis = todasSituacoesContabeis.length
          ? selectedSituacoesContabeisRaw.filter((k) => todasSituacoesContabeis.includes(k))
          : selectedSituacoesContabeisRaw;
        this.campos = {
          titulo: comparativo.titulo,
          bdgd: comparativo.bdgd,
          origemAis: comparativo.origem_ais == 'BANCO' ? 'BANCO DE DADOS' : comparativo.origem_ais,
          comparaTi: comparativo.compara_ti,
          considerarTiVazia: comparativo.considerar_ti_vazia,
          monthFormattedAis: comparativo.data_ais ? this.formatMonth(comparativo.data_ais) : '',
          monthAis: comparativo.data_ais ? this.formatMonthToPicker(comparativo.data_ais) : '',
          monthFormattedBdgd: comparativo.data_bdgd ? this.formatMonth(comparativo.data_bdgd) : '',
          monthBdgd: comparativo.data_bdgd ? this.formatMonthToPicker(comparativo.data_bdgd) : '',
          dataFormattedImobInicio: comparativo.data_imobilizacao_inicio
            ? this.formatDate(comparativo.data_imobilizacao_inicio)
            : '',
          dataImobInicio: comparativo.data_imobilizacao_inicio
            ? this.formatDateToPicker(comparativo.data_imobilizacao_inicio)
            : '',
          dataFormattedImobFim: comparativo.data_imobilizacao_fim ? this.formatDate(comparativo.data_imobilizacao_fim) : '',
          dataImobFim: comparativo.data_imobilizacao_fim ? this.formatDateToPicker(comparativo.data_imobilizacao_fim) : '',
          anual: comparativo.anual,
          sobraFisica: comparativo.sobra_fisica,
          dataCompleta: comparativo.data_completa,
          considerarMargem: comparativo.considerar_margem,
          tucs: this.campos.tucs,
          tucsSelected: this.tucs ? this.tucs : [],
          situacoesContabeis: todasSituacoesContabeis,
          situacoesContabeisSelected: selectedSituacoesContabeis,
          odis: comparativo.odis ? this.formatTextAreaValue(comparativo.odis) : ''
        };

        if (comparativo.arquivo_delimitador != null) {
          this.arquivoId = comparativo.arquivo_id;
          this.campos.arquivoDelimitador = comparativo.arquivo_delimitador;
          this.campos.arquivoInvolucro = comparativo.arquivo_involucro;
          this.campos.arquivoEscape = comparativo.arquivo_escape;
          this.setFakeFileForValidation(); /* Cria um arquivo fake temporario, serve apenas para passar pela validação */
        } else {
          this.getParamsArquivoCsv();
        }
      },

      formatTextAreaValue(valueString) {
        let value = valueString.substring(1, valueString.length - 1);
        return value.replace(/,/g, '').replace(/''/g, '\n');
      },

      uploadNewFile() {
        if (!this.arquivo) return;

        this.arquivoId = '';
        this.uploadInProgress = true;

        let data = new FormData();
        data.append('file', this.arquivo);

        ArquivosService.uploadFile(data)
          .then((response) => {
            this.arquivoId = response.data.arquivoId;
            this.fakeFileFound = false;
          })
          .catch((err) => {
            console.error(err);

            if (err?.data?.cod_erro == 10000) {
              let msg = 'Há mais de um arquido dentro do ZIP.<br>Adicione apenas um arquivo CSV.';
              this.$toast.error(msg, '', { position: 'topRight', timeout: 8000 });
            } else {
              this.$toast.error('Erro no upload do arquivo.', '', { position: 'topRight' });
            }

            this.arquivo = undefined;
          })
          .finally(() => {
            this.uploadInProgress = false;
          });
      },

      getParamsArquivoCsv() {
        ConfiguracoesService.getCsvCamposPadroes()
          .then((response) => {
            this.campos.arquivoDelimitador = response.data.campos.delimitador.valor;
            this.campos.arquivoInvolucro = response.data.campos.involucro.valor;
            this.campos.arquivoEscape = response.data.campos.escape.valor;
          })
          .catch((err) => {
            console.error('Erro ao recuperar campos padrões do arquivo csv: ', err);
            this.$toast.error('Erro ao recuperar campos padrões do arquivo csv.', '', { position: 'topRight' });
          });
      },

      setFakeFileForValidation() {
        ArquivosService.getNameArquivoById(this.arquivoId)
          .then((response) => {
            this.arquivo = new File([''], response.data.nome, { type: 'text/csv' });
            this.fakeFileFound = true;
          })
          .catch((err) => {
            console.error('Erro ao recuperar arquivo csv: ', err);
            this.$toast.error('Erro ao recuperar arquivo csv.', '', { position: 'topRight' });
          });
      },

      getUltimaDataBase() {
        return TabelasService.getTabelaResumo()
          .then((response) => {
            let data = response.data.tabela_resumo;

            this.campos.monthAis = data.data_base_ais ? data.data_base_ais : '';
            this.campos.monthBdgd = data.data_base_bdgd ? data.data_base_bdgd : '';
            this.campos.monthFormattedAis = data.data_base_ais ? this.formatMonth(data.data_base_ais + '-01') : '';
            this.campos.monthFormattedBdgd = data.data_base_bdgd ? this.formatMonth(data.data_base_bdgd + '-01') : '';
          })
          .catch((err) => {
            this.$toast.error('Erro ao tentar pegar última data base', '', { position: 'topRight' });
            console.error('Erro:', err);
          });
      },

      exportData() {
        if (this.campos.bdgd) {
          /* IF para caso a opção 'Apenas BDGD' estiver marcada */
          this.campos.monthAis = null;
        }

        return {
          titulo: this.campos.titulo,
          origem_ais: this.campos.origemAis == 'BANCO DE DADOS' ? 'BANCO' : this.campos.origemAis,
          data_bdgd: this.campos.monthBdgd + '-01',
          data_ais: this.campos.monthAis ? this.campos.monthAis + '-01' : null,
          data_imobilizacao_inicio: this.campos.dataImobInicio ? this.campos.dataImobInicio : null,
          data_imobilizacao_fim: this.campos.dataImobFim ? this.campos.dataImobFim : null,
          sobra_fisica: this.campos.sobraFisica,
          bdgd: this.campos.bdgd,
          compara_ti: this.campos.comparaTi,
          considerar_ti_vazia: this.campos.considerarTiVazia,
          anual: this.campos.anual,
          data_completa: this.campos.dataCompleta,
          considerar_margem: this.campos.considerarMargem,
          tucs: this.campos.tucsSelected.toString(),
          situacoes_contabeis: this.campos.situacoesContabeisSelected.toString(),
          odis: this.campos.odis,
          arquivo_id: this.campos.origemAis == 'ARQUIVO' ? this.arquivoId : null,
          arquivo_delimitador: this.campos.origemAis == 'ARQUIVO' ? this.campos.arquivoDelimitador : null,
          arquivo_involucro: this.campos.origemAis == 'ARQUIVO' ? this.campos.arquivoInvolucro : null,
          arquivo_escape: this.campos.origemAis == 'ARQUIVO' ? this.campos.arquivoEscape : null
        };
      },

      exportTypeTour() {
        return this.campos.bdgd
          ? 'apenas bdgd'
          : this.campos.origemAis.toLowerCase(); /* this.campos.bdgd == Apenas BDGD (checked) */
      },

      handleCheckbox(valor) {
        if (this.syncingSituacoesContabeis) return;
        if (valor) {
          this.campos.situacoesContabeisSelected = [...this.campos.situacoesContabeis];
        } else {
          this.campos.situacoesContabeisSelected = [];
        }
      },

      normalizeSituacoesContabeisSelected(raw) {
        if (raw == null) return [];
        if (Array.isArray(raw)) return raw.map(String).filter(Boolean);
        if (typeof raw === 'string') {
          const trimmed = raw.trim();
          if (!trimmed) return [];
          if (trimmed.startsWith('[') && trimmed.endsWith(']')) {
            const parsed = JSON.parse(trimmed);
            if (Array.isArray(parsed))
              return parsed
                .map(String)
                .map((s) => s.trim())
                .filter(Boolean);
          }
          const unquoted = trimmed.replace(/^['"]|['"]$/g, '');
          return unquoted
            .split(unquoted.includes(';') && !unquoted.includes(',') ? ';' : ',')
            .map((s) => s.trim())
            .filter(Boolean);
        }
        return [];
      }
    },

    watch: {
      items() {
        this.fillFields();
      },
      'campos.anual'(newValue) {
        if (newValue === true && this.campos.dataCompleta === true) this.campos.dataCompleta = false;
      },
      'campos.dataCompleta'(newValue) {
        if (newValue === true && this.campos.anual === true) this.campos.anual = false;
      },
      'campos.situacoesContabeisSelected'(newValue) {
        const all = this.campos.situacoesContabeis || [];
        const selected = Array.isArray(newValue) ? newValue : [];

        const allSelected = all.length > 0 && selected.length === all.length && all.every((item) => selected.includes(item));

        if (this.campos.sobraFisica !== allSelected) {
          this.syncingSituacoesContabeis = true;
          try {
            this.campos.sobraFisica = allSelected;
          } finally {
            this.syncingSituacoesContabeis = false;
          }
        }
      }
    }
  };
</script>

<style>
  .spacing-checkbox-sig-r div div .v-input__slot {
    margin-bottom: -12px !important;
  }
  .v-alert__icon {
    align-self: center;
  }
</style>
